// extracted by mini-css-extract-plugin
export default {"chat":"ChatCSS_chat__MDP24","text_one":"ChatCSS_text_one__sbZ4L","text_two":"ChatCSS_text_two__F6-6h","our_text":"ChatCSS_our_text__b5HhE"};